function mountSupport(root = document) {
  root.querySelectorAll('.c21-apps--product').forEach(section => {
    if (section.dataset.sortMounted) return;
    section.dataset.sortMounted = 'true';
    let chosen = false;
    const sort = () => {
      const select = section.querySelector('.jdgm-sort-dropdown');
      if (!select || !select.querySelector('option[value="highest-rating"]') || chosen) return false;
      chosen = true;
      select.value = 'highest-rating';
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    };
    // Judge.me can scroll to the widget when its sort changes. Wait until
    // customers reach the reviews, so opening a product stays at the top.
    const startSort = () => {
      if (sort()) return;
      const observer = new MutationObserver(() => { if (sort()) observer.disconnect(); });
      observer.observe(section, { childList: true, subtree: true });
      setTimeout(() => observer.disconnect(), 15000);
    };
    const heading = section.querySelector('.c21-reviews-intro') || section;
    if ('IntersectionObserver' in window) {
      const visible = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        visible.disconnect();
        startSort();
      }, { threshold: 0.25 });
      visible.observe(heading);
    }

  });
}
function styleDelivery() {
  const holder = document.querySelector('.product-details [data-c21-delivery]');
  if (!holder || holder.dataset.mounted) return;
  holder.dataset.mounted = 'true';
  const update = () => {
    const input = holder.querySelector('.cobay-edd-pincode-input');
    const button = holder.querySelector('.cobay-edd-check-btn');
    if (!input || !button) return;
    holder.querySelector('[data-c21-delivery-hint]').hidden = true;
    input.setAttribute('aria-label', input.placeholder || 'PIN code');
    for (const element of [input, button]) {
      element.style.setProperty('font-family', 'inherit', 'important');
      element.style.setProperty('height', '44px', 'important');
      element.style.setProperty('border-radius', '10px', 'important');
    }
    input.style.setProperty('border-color', '#dce5e0', 'important');
    button.style.setProperty('background-color', '#214b40', 'important');
  };
  update();
  new MutationObserver(update).observe(holder.querySelector('#cobay-edd-widget'), { childList: true, subtree: true });
}
mountSupport();
styleDelivery();
document.addEventListener('shopify:section:load', event => { mountSupport(event.target); styleDelivery(); });
